<template>  
    <section class="block block--hero">
        <div class="hero">
            <div
                class="hero__img"
                v-if="block.image" 
                :style="{ backgroundImage: `url('${$VUE_APP_API_URL + block.image.url}')` }"
                :alt="block.image.caption"></div>
                <vue-particles class="hero__particles"
                    color="#03010a"
                    :particleOpacity="0.5"
                    :particlesNumber="100"
                    shapeType="circle"
                    :particleSize="3"
                    linesColor="#ffffff"
                    :linesWidth="1"
                    :lineLinked="true"
                    :lineOpacity="0.5"
                    :linesDistance="200"
                    :moveSpeed="2"
                    :hoverEffect="true"
                    hoverMode="grab"
                    :clickEffect="true"
                    clickMode="push"></vue-particles>
            <div class="hero__overlay"></div>
            <div class="hero__content">
                <div class="container">
                    <h1 v-if="block.title">{{ block.title }}</h1>
                    <div v-if="block.subtitle" class="subtitle">{{ block.subtitle }}</div>
                    <div v-if="block.content" v-html="block.content"></div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

export default { 
    name: 'hero',

    props: {
        block: {
            type: Object,
            default: () => {}
        }
    }
}
</script>